module.exports = __webpack_public_path__ + "static/media/collaborate.f9201355.png";